export type FieldErrors = {
  name?: string;
  email?: string;
  message?: string;
};

export type SendState = {
  status: "idle" | "success" | "error";
  message: string;
  fieldErrors: FieldErrors;
};

export const initialSendState: SendState = {
  status: "idle",
  message: "",
  fieldErrors: {},
};
